/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Heading_ProductsInputs */

const ja_work_heading_products = /** @type {(inputs: Work_Heading_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

const en_work_heading_products = /** @type {(inputs: Work_Heading_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

/**
* | output |
* | --- |
* | "Products" |
*
* @param {Work_Heading_ProductsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const work_heading_products = /** @type {((inputs?: Work_Heading_ProductsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Heading_ProductsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_heading_products(inputs)
	return en_work_heading_products(inputs)
});